// src/components/common/EditConfirmationModal.js
import React from 'react';
import PropTypes from 'prop-types';

function EditConfirmationModal({ title, message, onConfirm, onCancel }) {
  return (
    <div 
      className="modal show d-block" 
      tabIndex="-1" 
      role="dialog" 
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onCancel} 
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            <button className="btn btn-primary" onClick={onConfirm}>Confirm Update</button>
          </div>
        </div>
      </div>
    </div>
  );
}

EditConfirmationModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

EditConfirmationModal.defaultProps = {
  title: 'Confirm Update',
  message: 'Are you sure you want to update this category?'
};

export default EditConfirmationModal;
